import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrokenImageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"broken_image"}/>
}
